import { useMemo, useState } from "react";
import { BoxesIcon } from "lucide-react";
import { Button } from "@devhop/ui";
import type { QiCatalogRawMaterialDTO } from "../api/catalog-types";
import { QiRawMaterialCatalogDialog } from "./QiRawMaterialCatalogDialog";

export function QiRawMaterialPicker({
  value,
  label,
  onSelect,
  disabled,
}: {
  value: string;
  label?: string;
  onSelect: (rawMaterial: QiCatalogRawMaterialDTO) => void;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(false);
  const [picked, setPicked] = useState<QiCatalogRawMaterialDTO | null>(null);

  const display = useMemo(() => {
    if (label) return label;
    if (picked?.id === value) return `${picked.code} — ${picked.name}`;
    return value ? value : "ເລືອກຈາກ catalog...";
  }, [label, picked, value]);

  return (
    <>
      <Button
        type="button"
        variant="outline"
        disabled={disabled}
        className={`h-9 w-full justify-start font-normal ${!value && !label ? "text-muted-foreground" : ""}`}
        onClick={() => setOpen(true)}
      >
        <BoxesIcon className="mr-2 h-4 w-4 shrink-0 opacity-60" />
        <span className="truncate">{display}</span>
      </Button>
      <QiRawMaterialCatalogDialog
        open={open}
        onOpenChange={setOpen}
        selectedId={value || undefined}
        onSelect={(rawMaterial) => {
          setPicked(rawMaterial);
          onSelect(rawMaterial);
        }}
      />
    </>
  );
}
